"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var INT_MAX_WIDTH_MENU = 720;
exports.MAX_WIDTH_MENU = INT_MAX_WIDTH_MENU + "px";
exports.DEFAULT_MAX_WIDTH_COLUMN = INT_MAX_WIDTH_MENU - 32 + "px";
//# sourceMappingURL=helpers.js.map